import {Content} from "#/src/pages/videos/Content";
import {Header} from "#/src/pages/videos/Header";
import {useEffect, useState} from "react";
import {composeHeaders, composeQuery} from "#/src/utils/api-request-utils";
import AppConstants from "#/src/utils/app-constants";
import {toast} from "react-toastify";
import {usePageContext} from "vike-react/usePageContext";
import {AppPageContext} from "#/src/definitions/AppDefinitions";
import {LiveStreamersHeader} from "#/src/components/LiveStreamersHeader";

export {Page}

function Page() {
  const pageContext = usePageContext() as AppPageContext;
  const [category, setCategory] = useState<"MAIN" | "AWAITING">("MAIN");
  const [query, setQuery] = useState<string | null>(null);
  const [queryData, setQueryData] = useState({isPending: true, error: false, data: null});
  useEffect(() => {
    if (query == null || query === "") {
      return;
    }
    setQueryData({...queryData, isPending: true});
    const queryParams = composeQuery({query});
    fetch(`${AppConstants.API_ROUTE}/videos/search?${queryParams}`, {
      method: "GET",
      headers: composeHeaders(pageContext)
    }).then(async response => {
      const data = await response.json();
      setQueryData({...queryData, isPending: false, data});
    }).catch(async response => {
      const errorResponse = await response.json() as any;
      if (errorResponse && errorResponse.errors) {
        errorResponse.errors.forEach(err => toast(err));
      }
    });
  }, [query]);
  return <>
    <LiveStreamersHeader/>
    <Header category={category} setCategory={setCategory} onQuery={setQuery}/>
    <Content category={category}
             query={{enabled: (query != null && query !== ""), isPending: queryData.isPending, error: queryData.error, queriedData: queryData.data}}/>
  </>
}
